import {BASE_PATH} from '$share/config'
import {createApi} from '$share/utils/api'
import {createAxios} from '$share/utils/axiosConfig'
import baseOrigin from '$utils/baseOrigin'

export const LOGIN_REQUIRED_API_PATH = ['/api', '/auth-api'] as const

export const internalInstance = createAxios({config: {baseURL: `${baseOrigin}${BASE_PATH}/api`, timeout: 3000}})
export const internalApi = createApi(internalInstance)

const frontApiGwInstance = createAxios({config: {baseURL: `${baseOrigin}/api`, timeout: 3000}})
export const gwApi = createApi(frontApiGwInstance)

const iawInstance = createAxios({config: {baseURL: `${baseOrigin}/mydata/api`, timeout: 3000}})
export const iawApi = createApi(iawInstance)

const simplepayInstance = createAxios({config: {baseURL: `${baseOrigin}/simplepay/api`, timeout: 3000}})
export const simplepayApi = createApi(simplepayInstance)

export const externalInstance = createAxios({config: {baseURL: `${baseOrigin}${BASE_PATH}/ext-api`, timeout: 3000}})
export const extApi = createApi(externalInstance)

export const authInstance = createAxios({config: {baseURL: `${baseOrigin}${BASE_PATH}/auth-api`, timeout: 3000}})
export const authApi = createApi(authInstance)
